/**
 * The Dashboard container
 */
import React from "react";
import PropTypes from "prop-types";
import { Route, Switch } from "react-router-dom";
import Loadable from "react-loadable";

/**
 * Dashboard container, the landing page for logged in users
 */

const UnlockableContentDetail = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "UnlockableContentDetail" */ "./UnlockableContentDetail"
    ),
  loading: () => null,
  modules: ["UnlockableContentDetail"],
});

const UnlockableContentsRoot = () => {
  return (
    <div>
      <Switch>
        <Route
          path={`/contents/:contentId`}
          component={UnlockableContentDetail}
        />
      </Switch>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
UnlockableContentsRoot.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default UnlockableContentsRoot;
